export const presetMarketAggregations = {
  '0x04661a095e27744f9f34b7dc950e49745e066a04bbc0bdf4689121172ab46019': 4
} as Record<string, number>
